module.exports = __webpack_public_path__ + "static/ashlyn-c6f41d1d2ea9a19fc324a5b71261b700.jpg";